<template>
  <div class="amount dropdown" v-on-click-outside="hideDropDown" v-if="items.length">
    <input id="dr-2" type="checkbox" v-model="showDropDown"/>
    <label for="dr-2">
      <span>{{ itemsPerPage }}</span>
      <span class="triangle"></span>
    </label>
    <ul>
      <li v-for="(item, index) in dropDown" v-if="item !== itemsPerPage" @click="dropDownClick(index)"
          v-bind:key="index">{{ item }}
      </li>
    </ul>
  </div>
</template>

<script>
  import {mixin as onClickOutside} from 'vue-on-click-outside'
  import {createNamespacedHelpers} from 'vuex'

  const {mapMutations, mapActions, mapState} = createNamespacedHelpers('mainPage')

  export default {
    name: 'Quantity',
    mixins: [onClickOutside],
    data () {
      return {
        showDropDown: false,
        dropDown: [5, 10, 20, 50, 100, 300]
      }
    },
    computed: {
      ...mapState([
        'itemsPerPage',
        'quantityItems',
        'items'
      ])
    },
    methods: {
      ...mapActions([
        'getItems'
      ]),
      ...mapMutations([
        'setItemsPerPage',
        'setItems',
        'setCurrentPage',
        'setPaginationParams',
        'setQuantityPages'
      ]),
      hideDropDown () {
        this.showDropDown = false
      },
      dropDownClick (index) {
        this.setItems([])
        this.hideDropDown()
        this.setItemsPerPage(this.dropDown[index])
        this.saveToLocalStorage(this.dropDown[index])
        this.setPaginationParams([
          {name: 'limit', value: this.itemsPerPage},
          {name: 'offset', value: 0}
        ])
        this.setCurrentPage(1)
        window.history.pushState({path:window.location.href}, '', `${window.location.origin}${window.location.pathname}?page=1`);
        this.setQuantityPages(Math.ceil(this.quantityItems / this.itemsPerPage))
        this.getItems()
      },
      saveToLocalStorage (index) {
        let currentPage = this.$route.path
        localStorage[currentPage] = index
      }
    },
    mounted () {
      let currentPage = this.$route.path
      if (localStorage[currentPage]) {
        let number = parseInt(localStorage[currentPage])
        this.setItemsPerPage(number)
      } else {
        this.setItemsPerPage(10)
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/filters/Quantity.vue